// Pure visibility predicates for the welcome coupon prompt. Extracted so the
// business gate (enabled AND positive amount AND logged-out, suppressed only by
// the prompt's own login modal) is unit-testable and can't silently regress.

// Steady-state visibility — ignores `suppressed`. Drives the once-per-page-view
// impression so opening/closing the login modal does not re-fire it.
export function couponSteadyVisible({ enabled, amount, currentUser }) {
  return Boolean(enabled) && Number(amount) > 0 && !currentUser
}

// Whether the pill should currently render. Adds the `suppressed` gate (true
// only while the prompt's own login modal is open).
export function welcomeCouponVisible({ enabled, amount, currentUser, suppressed }) {
  return !suppressed && couponSteadyVisible({ enabled, amount, currentUser })
}
